var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"custom-trim-example relative"},[_vm._l((_setup.trimEdgeList),function(item){return _c('span',{key:item.value,staticClass:"ellipsis dir color-o-9",class:[
      'absolute',
      item.value == 'top'
        ? 'img-top'
        : item.value == 'left'
        ? 'img-left'
        : item.value == 'right'
        ? 'img-right'
        : 'img-bottom',
    ],attrs:{"title":_setup.translateLang(item.label)}},[_vm._v(_vm._s(_vm.$t(item.label)))])}),_c('div',{staticClass:"inline-block img"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }